import { head, last } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { StatusGroup } from 'api/tasks';
import { ReactComponent as FirstPhase } from 'assets/svgs/phase-summary/first-phase.svg';
import { ReactComponent as LastPhase } from 'assets/svgs/phase-summary/last-phase.svg';
import { ReactComponent as Phase01 } from 'assets/svgs/phase-summary/PC01.svg';
import { ReactComponent as Phase02 } from 'assets/svgs/phase-summary/PC02.svg';
import { ReactComponent as Phase03 } from 'assets/svgs/phase-summary/PC03.svg';
import { ReactComponent as Phase04 } from 'assets/svgs/phase-summary/PC04.svg';
import { ReactComponent as Phase05 } from 'assets/svgs/phase-summary/PC05.svg';
import { ReactComponent as Phase06 } from 'assets/svgs/phase-summary/PC06.svg';
import { useProjectPhaseStatusField } from 'data/fields/hooks/account-fields';
import { PhaseStatusSummaryContainer } from './swimlane.style';

const phaseIcons = {
  firstPhase: FirstPhase,
  lastPhase: LastPhase,
  otherPhases: [Phase01, Phase02, Phase03, Phase04, Phase05, Phase06],
};

const Summary = styled.p`
  color: var(--gray-50);
  font-style: italic;
`;

const IconContainer = styled.span`
  width: var(--spacing-09);
  display: block;
  margin: auto;
`;

function randomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const IconRenderer = React.memo(
  ({
    currentPhaseId,
    allPhases,
  }: {
    currentPhaseId: number;
    allPhases: number[];
  }) => {
    const randomIndex = randomInteger(0, phaseIcons.otherPhases.length - 1);
    const RandomIcon = phaseIcons.otherPhases[randomIndex];

    if (currentPhaseId === head(allPhases)) {
      const FirstPhaseIcon = phaseIcons.firstPhase;

      return <FirstPhaseIcon />;
    }

    if (currentPhaseId === last(allPhases)) {
      const LastPhaseIcon = phaseIcons.lastPhase;

      return <LastPhaseIcon />;
    }

    return <RandomIcon />;
  },
);

export const PhaseStatusSummary = ({
  status,
  currentPhaseId,
  projectPhaseIds,
}: {
  status: number;
  currentPhaseId: number;
  projectPhaseIds: number[];
}) => {
  const projectPhaseStatusField = useProjectPhaseStatusField();
  const currentProjectPhaseStatus =
    projectPhaseStatusField.metaData.options.find(
      (_status) => _status.value === status,
    );

  if (currentProjectPhaseStatus?.value !== StatusGroup.Completed) {
    return null;
  }

  return (
    <PhaseStatusSummaryContainer>
      <IconContainer>
        <IconRenderer
          currentPhaseId={currentPhaseId}
          allPhases={projectPhaseIds}
        />
      </IconContainer>
      <Summary>
        <FormattedMessage id="projects.plan.phase.status.completed" />
      </Summary>
    </PhaseStatusSummaryContainer>
  );
};
